import {
    DataRecordValue,
    DataRecord,
    getMetricLabel,
    getColumnLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, PieSeriesOption, number } from 'echarts';
import {
    DEFAULT_FORM_DATA as DEFAULT_FUNNEL_FORM_DATA,
    EchartsNestedPieChartProps,
    EchartsNestedPieFormData,
    NestedPieChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import {
    extractGroupbyLabel,
} from '../../../utils/series';
import { convertToHexColor, getLegendObject } from '../../utils';
  
export default function transformProps(
    chartProps: EchartsNestedPieChartProps,
): NestedPieChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      groupbyInner,
      metric = '',
      tooltipFormat,
      labelFormat,
      labelBackgroundColor,
      labelBorderColor,
      labelRichStyle,
      showLegend,
      legendOrientation,
      legendMargin
    }: EchartsNestedPieFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_FUNNEL_FORM_DATA,
      ...formData,
    };

    const metricLabel = getMetricLabel(metric);
    
    const seriesA = Array.isArray(groupby) ? groupby[0] : groupby;
    const seriesB = Array.isArray(groupbyInner) ? groupbyInner[0] : groupbyInner;

    const outerGroupbyLabels = [getColumnLabel(seriesA)];
    const innerGroupbyLabels = [getColumnLabel(seriesB)];
    // const outerKeys = data.map(datum =>
    //   extractGroupbyLabel({ datum, groupby: outerGroupbyLabels, coltypeMapping: {} }),
    // );
    // const innerKeys = [...new Set(data.map(datum =>
    //   extractGroupbyLabel({ datum, groupby: innerGroupbyLabels, coltypeMapping: {} }),
    // ))];
    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: outerGroupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: outerGroupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;

    const innerPieSummary: { [label: string]: { name: string, value: number }} = {};

    const outerSeriesData = data.map(datum => {
      const label = extractGroupbyLabel({
        datum,
        groupby: outerGroupbyLabels,
        coltypeMapping: {},
      });
      
      const innerSeriesKey = datum[innerGroupbyLabels[0]] as string;

      if(innerSeriesKey in innerPieSummary) {
        innerPieSummary[innerSeriesKey].value = number.numericToNumber(datum[metricLabel])
      }
      else {
        innerPieSummary[innerSeriesKey] = {
          name: innerSeriesKey,
          value: number.numericToNumber(datum[metricLabel])
        }
      }

      return {
        name: label,
        value: datum[metricLabel]
      };
    });

    const innerSeriesData = Object.keys(innerPieSummary).map(key => innerPieSummary[key]);
    
    const series: PieSeriesOption[] = [
      {
        name: metricLabel,
        type: 'pie',
        animation: true,
        selectedMode: 'single',
        radius: [0, '30%'],
        label: {
          position: 'inner',
          fontSize: 14
        },
        labelLine: {
          show: false
        },
        // @ts-ignore
        data: innerSeriesData,
      },
      {
        name: metricLabel,
        type: 'pie',
        animation: true,
        radius: ['45%', '60%'],
        labelLine: {
          length: 30
        },
        label: {
          formatter: labelFormat,
          backgroundColor: convertToHexColor(labelBackgroundColor),
          borderColor: convertToHexColor(labelBorderColor),
          borderWidth: 1,
          borderRadius: 4,
          rich: JSON.parse(labelRichStyle)
        },
        // @ts-ignore
        data: outerSeriesData,
      },
    ];

    const echartOptions: EChartsCoreOption = {
      tooltip: {
        trigger: 'item',
        formatter: tooltipFormat
      },
      legend: {...getLegendObject(showLegend, legendOrientation,
        legendMargin ? legendMargin.toString() : undefined)},
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      seriesA,
      seriesB
    };
}
  